import { colors } from '../styles'

export const input = {
  variants: {
    disabled: {
      backgroundColor: colors.gray[50],
      border: `1px solid ${colors.gray[100]}`,
      boxSizing: 'border-box',
      boxShadow: '0px 1px 2px rgba(55, 65, 81, 0.08)',
      borderRadius: '4px',
    },
  },
}
